import _ from 'lodash'
import { useState, useEffect, useCallback } from 'react'
import { Stack, Typography, ToggleButton, ToggleButtonGroup, Box } from '@mui/material'
import BlockIcon from '@mui/icons-material/Block'
import HourglassTopIcon from '@mui/icons-material/HourglassTop'

const LaneSelectButton = ({ options, value, onChange, loading }): JSX.Element => {
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    setSelectedValue(value)
  }, [options, value])

  const handleToggleChange = useCallback((_event, newValue): void => {
    if (newValue !== null) {
      setSelectedValue(newValue)
      if (onChange) {
        onChange(newValue)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <Stack spacing={2} sx={{ pl: '4px', m: '1rem 0' }}>
        <Typography variant='body1'>เลือกช่องจอด</Typography>
        <ToggleButtonGroup sx={{ height: '50px' }} disabled>
          <ToggleButton value={null} sx={{ fontSize: '1.1rem', width: '50px' }}>
            <HourglassTopIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    )
  }

  return options < 1 ? (
    <Stack spacing={2} sx={{ pl: '4px', m: '1rem 0' }}>
      <Typography component='div' color='error'>
        <Box fontWeight='fontWeightMedium' display='inline'>
          สาขาถูกปิดในวันที่เลือก
        </Box>
      </Typography>
      <ToggleButtonGroup color='error' value={null} sx={{ height: '50px' }} disabled>
        <ToggleButton value={null} sx={{ fontSize: '1.1rem', width: '50px' }}>
          <BlockIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  ) : (
    <Stack spacing={2} sx={{ pl: '4px', m: '1rem 0' }}>
      <Typography variant='body1'>เลือกช่องจอด</Typography>
      <ToggleButtonGroup
        color='primary'
        value={selectedValue}
        exclusive
        onChange={handleToggleChange}
        sx={{ height: '50px' }}
      >
        {Array(options)?.length ? (
          _.map([...Array(options)], (option, idx) => (
            <ToggleButton key={option} value={idx + 1} sx={{ fontSize: '1.1rem', width: '50px' }}>
              {idx + 1}
            </ToggleButton>
          ))
        ) : (
          <ToggleButton
            disabled
            value={null}
            sx={{ fontSize: '1.1rem', width: '50px', visibility: 'hidden' }}
          ></ToggleButton>
        )}
      </ToggleButtonGroup>
    </Stack>
  )
}

export default LaneSelectButton
